import { Navigate, Route, Routes } from 'react-router-dom';

import AltaDePrestamo from './pantallas/AltaDePrestamo.jsx';
import CancelarPlanDePagos from './pantallas/CancelarPlanDePagos.jsx';
import DetalleDelPrestamo from './pantallas/DetalleDelPrestamo.jsx';
import GenerarPlanDePagos from './pantallas/GenerarPlanDePagos.jsx';
import PagoAdelantadoDePrestamo from './pantallas/PagoAdelantadoDePrestamo.jsx';
import RegistrarPagoDePrestamo from './pantallas/RegistrarPagoDePrestamo.jsx';

/**
 * Rutas internas del incremento 20/21 · Préstamos: alta y pagos (RF-264 a RF-271).
 *
 * EL MÓDULO NO RECLAMA LUGAR EN LA BARRA INFERIOR Y NO DESPLAZA A NADIE: cuelga del
 * destino «Cuentas» que el 2/6 ya registró, igual que los meses sin intereses (4/6)
 * y el panel de vencimientos (6/6). Un préstamo ES una cuenta —de tipo Préstamo
 * (D-434)—, así que su sitio natural es ese destino y no uno nuevo.
 *
 * LAS NUEVE PANTALLAS DEL PROTOTIPO APROBADO v46 se reparten así:
 *   · P-20-01 alta del préstamo y su plan .......... `nuevo`
 *   · P-20-02 detalle con su plan .................. `:idCuenta`
 *   · P-20-08 la hipoteca año por año .............. `:idCuenta` (el mismo detalle,
 *     con el calendario plegado: el pliegue es PRESENTACIÓN y lo decide el número de
 *     pagos, no la ruta — RN-776, D-451)
 *   · P-20-06 el préstamo sin plan todavía ......... `:idCuenta` (el mismo detalle,
 *     con `planGenerado = false`; no es error — RN-778, D-457)
 *   · P-20-03 registrar un pago .................... `:idCuenta/pagos/nuevo`
 *   · P-20-07 cancelar el plan de pagos ............ `:idCuenta/plan/cancelacion`
 *   · el plan sobre un préstamo que ya existe ...... `:idCuenta/plan`
 *   · P-20-04 el renglón en lo que vence ........... lo pinta el panel del 6/6
 *   · P-20-05 los dos movimientos del pago ......... los pinta el historial del 3/6
 *
 * NINGUNA SUPERFICIE DE TARJETA SE OFRECE AQUÍ (RN-752): no hay —ni puede haber—
 * ruta de fechas de corte, de renovación de plástico, de meses sin intereses, de
 * diferido declarado ni de reconciliación.
 */
export default function Prestamos() {
  return (
    <Routes>
      <Route path="nuevo" element={<AltaDePrestamo />} />
      <Route path=":idCuenta" element={<DetalleDelPrestamo />} />
      <Route path=":idCuenta/plan" element={<GenerarPlanDePagos />} />
      <Route path=":idCuenta/plan/cancelacion" element={<CancelarPlanDePagos />} />
      <Route path=":idCuenta/pagos/nuevo" element={<RegistrarPagoDePrestamo />} />
      {/* Incremento 21/21 · ABONAR A CAPITAL (RF-276, prototipo v48). Es una ruta
          propia y no una pestaña del pago normal porque son DOS HECHOS DISTINTOS
          (D-467): el pago del mes cubre la mensualidad, el abono baja la deuda y no
          la cubre. Mezclarlos en una pantalla es exactamente la confusión que
          RN-788 existe para evitar. */}
      <Route path=":idCuenta/pagos-adelantados/nuevo" element={<PagoAdelantadoDePrestamo />} />
      <Route path="*" element={<Navigate to="/cuentas" replace />} />
    </Routes>
  );
}
